import { useEffect, useState } from "react";
import "./networkStatus.scss";

const GoodIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.46967 11.9697C6.76256 11.6768 7.23744 11.6768 7.53033 11.9697L10 14.4393L16.4697 7.96967C16.7626 7.67678 17.2374 7.67678 17.5303 7.96967C17.8232 8.26256 17.8232 8.73744 17.5303 9.03033L10.5303 16.0303C10.2374 16.3232 9.76256 16.3232 9.46967 16.0303L6.46967 13.0303C6.17678 12.7374 6.17678 12.2626 6.46967 11.9697Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z" fill="currentColor" />
    </svg>
);

const WeakIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V7C11.25 6.58579 11.5858 6.25 12 6.25Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.5117 16.4414C12.8196 16.7185 12.8446 17.1927 12.5675 17.5006L12.5575 17.5117C12.2804 17.8196 11.8062 17.8446 11.4983 17.5675C11.1904 17.2904 11.1654 16.8162 11.4425 16.5083L11.4525 16.4972C11.7296 16.1893 12.2038 16.1643 12.5117 16.4414Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z" fill="currentColor" />
    </svg>
);

const SlowIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.61617 3.64141C10.6736 1.80247 13.3268 1.80247 14.3841 3.64141L22.4271 17.6291C23.4813 19.4625 22.1579 21.7499 20.0431 21.7499H3.95721C1.84242 21.7499 0.519055 19.4625 1.57322 17.6291L9.61617 3.64141ZM13.0838 4.38912C12.6032 3.55324 11.3972 3.55324 10.9165 4.38912L2.87358 18.3769C2.39441 19.2102 2.99594 20.2499 3.95721 20.2499H20.0431C21.0044 20.2499 21.6059 19.2102 21.1267 18.3769L13.0838 4.38912Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 8.24994C12.4144 8.24994 12.7502 8.58573 12.7502 8.99994V12.9999C12.7502 13.4142 12.4144 13.7499 12.0002 13.7499C11.5859 13.7499 11.2502 13.4142 11.2502 12.9999V8.99994C11.2502 8.58573 11.5859 8.24994 12.0002 8.24994Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.5119 16.4414C12.8198 16.7185 12.8447 17.1927 12.5676 17.5006L12.5576 17.5117C12.2805 17.8195 11.8063 17.8445 11.4984 17.5674C11.1906 17.2903 11.1656 16.8161 11.4427 16.5082L11.4527 16.4971C11.7298 16.1892 12.204 16.1643 12.5119 16.4414Z" fill="currentColor" />
    </svg>
);

const OfflineIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
);

const DefaultIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.25 5C4.25 4.58579 4.58579 4.25 5 4.25H19C19.4142 4.25 19.75 4.58579 19.75 5C19.75 8.08811 17.9438 10.7544 15.3302 12C17.9438 13.2456 19.75 15.9119 19.75 19C19.75 19.4142 19.4142 19.75 19 19.75H5C4.58579 19.75 4.25 19.4142 4.25 19C4.25 15.9119 6.05618 13.2456 8.66976 12C6.05618 10.7544 4.25 8.08811 4.25 5ZM12 12.75C8.80204 12.75 6.16505 15.1518 5.79454 18.25H18.2055C17.8349 15.1518 15.198 12.75 12 12.75ZM5.79454 5.75C6.16506 8.84817 8.80204 11.25 12 11.25C15.198 11.25 17.8349 8.84817 18.2055 5.75H5.79454Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.25 2C4.25 1.58579 4.58579 1.25 5 1.25H19C19.4142 1.25 19.75 1.58579 19.75 2C19.75 2.41421 19.4142 2.75 19 2.75H5C4.58579 2.75 4.25 2.41421 4.25 2Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.25 22C4.25 21.5858 4.58579 21.25 5 21.25H19C19.4142 21.25 19.75 21.5858 19.75 22C19.75 22.4142 19.4142 22.75 19 22.75H5C4.58579 22.75 4.25 22.4142 4.25 22Z" fill="currentColor" />
    </svg>
);

const NetworkStatus = ({ useToast = true }) => {
    const [status, setStatus] = useState("Checking...");
    const [visible, setVisible] = useState(true);

    const getMessage = () => {
        switch (status) {
            case "Good":
                return {
                    title: useToast ? "Good Connection." : "Good Connection",
                    subtitle: useToast ? "Network is good." : "Your network connection is good.",
                    cssClass: "network-status-good",
                    textColor: "#197335",
                    icon: <GoodIcon />
                };
            case "Weak":
                return {
                    title: useToast ? "Weak Connection." : "Weak Connection",
                    subtitle: useToast ? "Network is very weak. Uploads may take longer. Please consider checking your connection." : "Your network connection is very weak for use of this application.",
                    cssClass: "network-status-weak",
                    textColor: "#A40011",
                    icon: <WeakIcon />
                };
            case "Slow":
                return {
                    title: useToast ? "Slow Connection." : "Slow Connection",
                    subtitle: useToast ? "Network is slow. Upload may take longer." : "Your network connection is slow for proper use of this application.",
                    cssClass: "network-status-slow",
                    textColor: "#975100",
                    icon: <SlowIcon />
                };
            case "Offline":
                return {
                    title: useToast ? "You are offline." : "You are offline",
                    subtitle: "Please check your connection.",
                    cssClass: "network-status-offline",
                    textColor: "#A40011",
                    icon: <OfflineIcon />
                };
            default:
                return {
                    title: "Checking network...",
                    subtitle: "Please wait.",
                    cssClass: "network-status-default",
                    textColor: "#383d41",
                    icon: <DefaultIcon />
                };
        }
    };

    const updateStatus = (newStatus) => setStatus(newStatus);

    const checkNetworkAPI = () => {
        if (!navigator.onLine) {
            updateStatus("Offline");
            return;
        }
        if (navigator.connection) {
            const { effectiveType, downlink } = navigator.connection;            
            if (downlink < 0.5 || effectiveType === "slow-2g") updateStatus("Weak");
            else if (downlink < 1.5 || effectiveType === "2g" || effectiveType === "3g") updateStatus("Slow");
            else updateStatus("Good");
        } else {
            updateStatus("Unknown");
        }
    };

    useEffect(() => {
        checkNetworkAPI();
        const interval = setInterval(checkNetworkAPI, 5000);
        window.addEventListener("online", () => updateStatus("Good"));
        window.addEventListener("offline", () => updateStatus("Offline"));
        return () => {
            clearInterval(interval);
            window.removeEventListener("online", () => updateStatus("Good"));
            window.removeEventListener("offline", () => updateStatus("Offline"));
        };
    }, []);

    const message = getMessage();
    if (!visible) return null;

    return (
        <>
            {useToast ? (
                <div className={`network-status-toast ${message.cssClass} ${status === "Good" ? "hidden" : ""}`}>
                    <div className="network-status-icon-container">
                        <span>
                            <div className="network-status-icon-symbol">
                                {message.icon}
                            </div>
                        </span>                        
                    </div>
                    <div className="network-status-text-container">
                        <div className="title">{message.title}</div>
                        <div className="subtitle">{message.subtitle}</div>
                    </div>
                    <button onClick={() => setVisible(false)} className="close-btn">
                        ✕
                    </button>
                </div>
            ) : (
                <div className="network-status-inline">
                    <span className={`status-badge ${status.toLocaleLowerCase()}`} title={message.subtitle}>
                        <span className="dot"></span>
                        {message.title.replace(".", "")}
                    </span>
                </div>
            )}
        </>
    );
};

export default NetworkStatus;